import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useBuildMenuItem, useMenu } from '@ers/hooks';
import { useDispatch } from 'react-redux';
import MenuItemBody from './MenuItemBody';

export default function MenuItem({ children, type }) {
    const [url, onClick, isActive] = useBuildMenuItem(type);
    const { close } = useMenu();
    const dispatch = useDispatch();
    const handleClick = useCallback(() => {
        onClick && onClick(dispatch);
        close();
    });

    return (
        <MenuItemBody isActive={isActive} handleClick={handleClick} url={url}>
            {children}
        </MenuItemBody>
    );
}
MenuItem.propTypes = {
    type: PropTypes.string
};
MenuItem.defaultProps = {
    type: ''
};
